
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class CardFooterData extends Vue {
  @Prop() item!: any;
  @Prop({ default: "mt-3 mb-2" }) classComponent!: string;
  @Prop() isCard!: any;
}
